<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <h1>
                <span jhiTranslate="study-editor.field-map.field.plan.title">FIELD PLAN</span>&nbsp;
                <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
            </h1>
        </div>
    </div>
    <div class="card panel-default">
        <div class="card-body">
            <div class="row mb-4">
                <div class="col-md-12">
                    <ul class="nav nav-underline nav-fill">
                        <li class="nav-item text-start">
                            <h3 jhiTranslate="study-editor.field-map.make.field.plan">Make a Field Plan</h3>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="fieldPlanStep === 1 ? 'active' : 'disabled'">
                                <h4 jhiTranslate="study-editor.field-map.enter.field.details">1. ENTER FIELD DETAILS</h4>
                            </a>
                        </li>
                        <li class="nav-item" >
                            <a class="nav-link" [ngClass]="fieldPlanStep === 2 ? 'active' : 'disabled'">
                                <h4 jhiTranslate="study-editor.field-map.enter.planting.details">2. ENTER PLANTING DETAILS</h4>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="fieldPlanStep === 3 || isViewFieldMap ? 'active' : 'disabled'">
                                <h4 jhiTranslate="study-editor.field-map.generate.field.map">3. GENERATE FIELD MAP</h4>
                            </a>

                        </li>
                    </ul>
                </div>
            </div>
            @if (fieldPlanStep === 1) {
                <div class="row mb-3">
                    <h5 class="fw-bold" jhiTranslate="study-editor.field-map.study.to.be.mapped">STUDY TO BE MAPPED:</h5>
                    <div class="col-sm-12">
                        <span class="mandatory-asterisk"></span><span jhiTranslate="study-editor.field-map.mandatory.field"></span>
                    </div>
                </div>}
            @if (fieldPlanStep === 3 || isViewFieldMap) {
                <div class="row mb-3">
                    <div class="col-sm-12">
                        <h5 class="fw-bold" jhiTranslate="study-editor.field-map.summary.of.study">SUMMARY OF STUDY, FIELD AND PLANTING DETAILS</h5>
                    </div>
                </div>}
            @if (fieldPlanStep === 1 || fieldPlanStep === 3 || isViewFieldMap) {
                <div class="row mb-2">
                    <div class="col-sm-12 mb-2">
                        <span class="col-form-label"><b jhiTranslate="study-editor.field-map.selected.studies">Selected Studies:</b></span>
                    </div>
                    @if (fieldPlanStep === 1) {
                        <div class="col-sm-12 mb-2">
                            <span jhiTranslate="study-editor.field-map.drag.note">Note: Arrange the order of the selected nurseries to be planted in the field map.</span>
                        </div>}
                    <div class="col-sm-12 mb-3">
                        <div class="container-fluid px-0 pt-3">
                            <div class="table-responsive custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;"
                                 cdkDropList (cdkDropListDropped)="fieldPlanStep === 1 ? drop($event) : null">
                                <table class="table table-striped table-bordered table-curved">
                                    <thead class="sticky-header">
                                    <tr>
                                        <th>{{ 'study-editor.field-map.order.header' | translate }}</th>
                                        <th>{{ 'study-editor.field-map.study.header' | translate }}</th>
                                        <th>{{ 'study-editor.field-map.environment.header' | translate }}</th>
                                        <th>{{ 'study-editor.field-map.location.name.header' | translate }}</th>
                                        <th>{{ 'study-editor.field-map.no.of.entries.header' | translate }}</th>
                                        <th>{{ 'study-editor.field-map.no.of.reps.header' | translate }}</th>
                                        <th>{{ 'study-editor.field-map.plots.needed.header' | translate }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        @for (info of selectedEnvironments; track info.instanceId; let row = $index;) {
                                            <tr cdkDrag [cdkDragDisabled]="fieldPlanStep !== 1">
                                                <td>{{row + 1}}</td>
                                                <td>{{studyName}}</td>
                                                <td>{{info.instanceNumber}}</td>
                                                <td>{{info.instanceNumber + '-' + info.locationName}}</td>
                                                <td>{{info.entriesCount}}</td>
                                                <td>{{info.replicatesCount}}</td>
                                                <td>{{info.plotsCount}}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-12">
                                <span class="col-form-label"><b jhiTranslate="study-editor.field-map.total.plots">Total Number of Plots:</b>{{totalNumberOfPlotsNeeded}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                @if (!isViewFieldMap) {
                    <div class="row mb-3">
                        <div class="col-sm-12">
                            <h5 class="fw-bold" jhiTranslate="study-editor.field-map.field.block.details">FIELD AND BLOCK DETAILS:</h5>
                        </div>
                    </div>
                    <div class="row mb-1">
                        @if (fieldPlanStep === 1) {
                            <div class="col-sm-12">
                                <strong>
                                    <span jhiTranslate="study-editor.field-map.add.field.block.details">Add new field and block details:</span>
                                </strong>
                            </div>}
                        <div class="mb-3 row required">
                            <label for="dropdownLocations" class="col-sm-2 col-form-label fw-bold" jhiTranslate="study-editor.field-map.field.location"></label>
                            <div class="col-sm-3">
                                <jhi-locations-select id="dropdownLocations" [(value)]="locationId" [showFilterOptions]="false" [clearable]="false" [disabled]="true"></jhi-locations-select>
                            </div>
                        </div>
                    </div>}}
            @if (fieldPlanStep === 1) {
                <div class="row mb-3">
                    <h5 class="fw-bold" jhiTranslate="study-editor.field-map.row.range.plot.details">ROW, RANGE AND PLOT DETAILS:</h5>
                    <div class=" row">
                        <div class="col-sm-6">
                            <div class="row mb-2">
                                <label for="rowsInBlock" class="col-sm-6 col-form-label fw-bold" translate="study-editor.field-map.number.of.rows.in.block">
                                </label>
                                <div class="col-sm-6">
                                    <input type="number" class="form-control" id="rowsInBlock" [(ngModel)]="rowsInBlock" (ngModelChange)="onPlotDetailsChange()" min="1" required>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-2">
                            <div class="row">
                                <label for="rowsPerPlot" class="col-sm-6 col-form-label fw-bold" translate="study-editor.field-map.number.of.rows.per.plot">
                                </label>
                                <div class="col-sm-6">
                                    <input type="number" class="form-control" id="rowsPerPlot" [(ngModel)]="rowsPerPlot" (ngModelChange)="onPlotDetailsChange()" min="1" max="12" required>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <div class="row">
                                <label for="rangesInBlock" class="col-sm-6 col-form-label fw-bold" translate="study-editor.field-map.number.of.ranges.in.block">
                                </label>
                                <div class="col-sm-6">
                                    <input type="number" class="form-control" id="rangesInBlock" [(ngModel)]="rangesInBlock" (ngModelChange)="onPlotDetailsChange()" min="1" required>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <label class="col-sm-6 col-form-label fw-bold" translate="study-editor.field-map.total.plots"></label>
                                <label class="col-sm-6 col-form-label">{{totalNumberOfPlots}}</label>
                            </div>
                        </div>
                    </div>
                </div>}
            @if (fieldPlanStep === 2) {
                <div class="row mb-3">
                    <div class="col-sm-12">
                        <h5 class="fw-bold" jhiTranslate="study-editor.field-map.planting.details">Planting Details:</h5>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-sm-12 mb-2">
                        <span class="mandatory-asterisk"></span><span jhiTranslate="study-editor.field-map.mandatory.field"></span>
                    </div>
                    <div class=" row">
                        <div class="col-sm-6">
                            <div class="row">
                                <label for="column" class="col-sm-4 col-form-label fw-bold" translate="study-editor.field-map.starting.coordinates">
                                </label>
                                <div class="col-sm-8">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <input type="number" class="form-control" id="column" [(ngModel)]="column" min="1" required>
                                        </div>
                                        <strong class="col-sm-3 col-form-label"><em translate="study-editor.field-map.column"></em></strong>
                                        <div class="col-sm-3">
                                            <input type="number" class="form-control col-sm-3" id="range" [(ngModel)]="range" min="1" required>
                                        </div>
                                        <strong class="col-sm-3 col-form-label"><em translate="study-editor.field-map.range"></em></strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <label class="col-sm-4 col-form-label fw-bold" translate="study-editor.field-map.plot.layout.order"><span class="mandatory-asterisk"></span></label>
                                <div class="col-sm-8 d-flex align-items-center">
                                    <div class="mb-3">
                                        <input type="radio" id="rowCol" name="plotLayoutOrder" [(ngModel)]="isSerpentine" [value]="false" checked>
                                        <label class="ms-1 col-form-label" for="rowCol" translate="study-editor.field-map.row.column"></label>
                                    </div>
                                    <div class="mb-3">
                                        <input class="ms-3" type="radio" id="isSerpentine" name="plotLayoutOrder" [(ngModel)]="isSerpentine" [value]="true" checked>
                                        <label class="ms-1 col-form-label" for="isSerpentine" translate="study-editor.field-map.serpentine"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <div class="row">
                                <label class="col-sm-4 col-form-label fw-bold" translate="study-editor.field-map.row.capacity">
                                </label>
                                <div class="col-sm-8 d-flex align-items-center">
                                    <ng-select [(ngModel)]="rowCapacity"
                                               [items]="rowCapacityOptions"
                                               [clearable]="false" style="flex: 1;" #select>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <h5 class="fw-bold" jhiTranslate="study-editor.field-map.unavailable.plots">UNAVAILABLE PLOTS</h5>
                        <div class="col-sm-12">
                            <span jhiTranslate="study-editor.field-map.unavailable.plots.label"></span>
                        </div>
                    </div>
                </div>}
            @if (isViewFieldMap) {
                <div class="row mt-2 mb-3">
                    <div class="col-sm-4">
                        <div class="row mb-3">
                            <h5 class="fbk-study-heading mb-0 fw-bold" jhiTranslate="study-editor.field-map.field.block.details.label">FIELD AND BLOCK DETAILS</h5>
                        </div>
                        <div class="row">
                            <span class="col-form-label"><b jhiTranslate="study-editor.field-map.field.location">Field Location:</b>{{ selectedEnvironments[0].locationName }}</span>
                        </div>
                        <div class="row">
                            <span class="col-form-label"><b jhiTranslate="study-editor.field-map.field.name">Field Name:</b></span>
                        </div>
                        <div class="row">
                            <span class="col-form-label"><b jhiTranslate="study-editor.field-map.block.name">Block Location:</b>{{ blockName }}</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="row mb-3">
                            <h5 class="fbk-study-heading mb-0 fw-bold" jhiTranslate="study-editor.field-map.row.range.plot.details.label">ROW, RANGE AND PLOT DETAILS</h5>
                        </div>
                        <div class="row">
                            <span class="col-form-label"><b jhiTranslate="study-editor.field-map.block.capacity">Block Capacity:</b>{{ getBlockCapacity() }}</span>
                        </div>
                        <div class="row">
                            <span class="col-form-label"><b jhiTranslate="study-editor.field-map.rows.per.plot">Rows per Plot:</b>{{ rowsPerPlot }}</span>
                        </div>
                        <div class="row">
                            <span class="col-form-label"><b jhiTranslate="study-editor.field-map.columns">Columns:</b>{{ rowsInBlock / rowsPerPlot }}</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="row mb-3">
                            <h5 class="fbk-study-heading mb-0 fw-bold" jhiTranslate="study-editor.field-map.planting.details">PLANTING DETAILS</h5>
                        </div>
                        <div class="row">
                            <span class="col-form-label"><b jhiTranslate="study-editor.field-map.starting.coordinates">Starting Coordinates:</b>{{ getStartingCoordinates() }}</span>
                        </div>
                        <div class="row">
                            <span class="col-form-label"><b jhiTranslate="study-editor.field-map.plot.layout.order">Plot Layout Order: </b>{{ getPlotLayoutOrder() }}</span>
                        </div>
                        <div class="row">
                            <span class="col-form-label"><b jhiTranslate="study-editor.field-map.row.capacity">Row Capacity of Planting Machine:</b>{{ rowCapacity }}</span>
                        </div>
                    </div>
                </div>}
            @if (fieldPlanStep === 3 || isViewFieldMap) {
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-inline-flex">
                        <h5 class="fbk-study-heading mb-0 fw-bold" jhiTranslate="study-editor.field-map.field.map">FIELD MAP</h5>
                    </div>
                    <div class="d-inline-flex">
                        <div ngbDropdown container="body" class="d-inline-block ps-2" placement="bottom-right">
                            <button  class="btn btn-info" id="columnsDropdown" ngbDropdownToggle>
                                <span translate="study-editor.field-map.actions"></span>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="columnsDropdown">
                                <button ngbDropdownItem (click)="exportToExcel()">{{ 'study-editor.field-map.actions.export' | translate }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <span>{{ 'study-editor.field-map.arrows.label' | translate }}</span>
                </div>}
            @if (fieldPlanStep !== 1) {
                <div class="fieldmap-container custom-scroll-style mt-2" style="overflow:auto; height:400px;">
                    <table id="field-map" class="table table-condensed" border="1">
                        <thead class="sticky-header">
                        <!-- Header row with row numbers -->
                        <tr>
							<td class="header-row-main" style="width: 70px"><span jhiTranslate="study-editor.field-map.rows">Rows</span></td>
                            @for (j of getSequence(1, rowsInBlock); track j) {
                                <td class="header-row-main">
                                    <p>{{ j }}</p>
                                </td>}
                        </tr>
                        <!-- Machine direction arrows row -->
                            @if (!isFieldmapEmpty() && fieldPlanStep !== 2) {
                                <tr class="machineDirectionRow">
                                    <td class="header-row-main"></td>
                                    @for (j of getSequence(1, Math.floor(rowsInBlock / rowCapacity)); track j) {
                                        <td
                                                class="sub-header-row"
                                                [attr.colspan]="rowCapacity">
                                            @if (j % 2 === 1) {
                                                <p>
                                                    <span class="glyphicon glyphicon-arrow-up"></span>
                                                </p>}
                                            @if (j % 2 === 0) {
                                                <p>
                                                    <span class="glyphicon glyphicon-arrow-down"></span>
                                                </p>}
                                        </td>}
                                    @if (rowsInBlock % rowCapacity !== 0) {
                                        <td
                                                class="sub-header-row"
                                                [attr.colspan]="rowsInBlock % rowCapacity">
                                            @if (getRemainderDirection(); as direction) {
                                                @if (direction === 'up') {
                                                    <p>
                                                        <span class="glyphicon glyphicon-arrow-up"></span>
                                                    </p>}
                                                @if (direction === 'down') {
                                                    <p>
                                                        <span class="glyphicon glyphicon-arrow-down"></span>
                                                    </p>}
                                            }
                                        </td>}
                                </tr>}
                        <!-- Column headers -->
                        <tr>
                            <td class="header-row-main"></td>
                            @for (j of getSequence(1, Math.floor(rowsInBlock / rowsPerPlot)); track j) {
                                <td
                                        class="sub-header-col"
                                        [title]="fieldPlanStep === 2 ? ( 'study-editor.field-map.field.plan.column.unusable.title' | translate ) : ''"
                                        [attr.colspan]="rowsPerPlot"
                                        (click)="onColumnHeaderClick(j-1)">
                                    <p><span jhiTranslate="study-editor.field-map.column.prefix">Column </span>&nbsp;{{ j }}</p>
                                </td>}
                        </tr>
                        </thead>
                        <tbody>
                        <!-- Plot rows -->
                            @for (i of getSequence(rangesInBlock, 1); track i) {
                                <tr class="plotRow">
                                    <td
                                            class="sub-header-row"
                                            [title]="fieldPlanStep === 2 ? ( 'study-editor.field-map.field.plan.range.unusable.title' | translate ) : ''"
                                            (click)="onRangeHeaderClick(i-1)">
                                        <p><span jhiTranslate="study-editor.field-map.range.prefix">Range </span>&nbsp;{{ i }}</p>
                                    </td>
                                    @for (j of getSequence(1, Math.floor(rowsInBlock / rowsPerPlot)); track j) {
                                        <td
                                                class="plot"
                                                [class.deleted]="getPlot(j-1, i-1)?.isPlotDeleted"
                                                [title]="fieldPlanStep === 2 ? ( 'study-editor.field-map.field.plan.plot.unusable.title' | translate ) : ''"
                                                [id]="(j-1) + '_' + (i-1)"
                                                [attr.colspan]="rowsPerPlot"
                                                (click)="onPlotClick(j-1, i-1)">
                                    <span class="plotLabel">
                                        @if (!getPlot(j-1, i-1)?.isPlotDeleted) {
                                            <p [innerHTML]="getDisplayString(getPlot(j-1, i-1))">
                                        </p>}
                                        @if (getPlot(j-1, i-1)?.isPlotDeleted) {
                                            <p class="deleted-p">
                                            <label class='alert alert-danger'><i class="fa fa-times fa-red"></i></label>
                                        </p>}
                                    </span>
                                        </td>}
                                </tr>}

                        <!-- Bottom column headers -->
                        <tr>
                            <td class="header-row-main"></td>
                            @for (j of getSequence(1, Math.floor(rowsInBlock / rowsPerPlot)); track j) {
                                <td
                                        class="sub-header-col"
                                        [title]="fieldPlanStep === 2 ? ( 'study-editor.field-map.field.plan.column.unusable.title' | translate ) : ''"
                                        [attr.colspan]="rowsPerPlot"
                                        (click)="onColumnHeaderClick(j-1)">
                                    <p><span jhiTranslate="study-editor.field-map.column.prefix">Column </span>&nbsp;{{ j }}</p>
                                </td>}
                        </tr>

                        <!-- Bottom machine direction arrows -->
                            @if (!isFieldmapEmpty()  && fieldPlanStep !== 2) {
                                <tr class="machineDirectionRow">
                                    <td class="header-row-main"></td>
                                    @for (j of getSequence(1, Math.floor(rowsInBlock / rowCapacity)); track j) {
                                        <td
                                                class="sub-header-row"
                                                [attr.colspan]="rowCapacity">
                                            @if (j % 2 === 1) {
                                                <p>
                                                    <span class="glyphicon glyphicon-arrow-up"></span>
                                                </p>}
                                            @if (j % 2 === 0) {
                                                <p>
                                                    <span class="glyphicon glyphicon-arrow-down"></span>
                                                </p>}
                                        </td>}
                                    @if (rowsInBlock % rowCapacity !== 0) {
                                        <td
                                                class="sub-header-row"
                                                [attr.colspan]="rowsInBlock % rowCapacity">
                                            @if (getRemainderDirection(); as direction) {
                                                @if (direction === 'up') {
                                                    <p>
                                                        <span class="glyphicon glyphicon-arrow-up"></span>
                                                    </p>}
                                                @if (direction === 'down') {
                                                    <p>
                                                        <span class="glyphicon glyphicon-arrow-down"></span>
                                                    </p>}
                                            }
                                        </td>}
                                </tr>}
                        <!-- Bottom row numbers -->
                        <tr>
                            <td class="header-row-main">Rows</td>
                            @for (j of getSequence(1, rowsInBlock); track j) {
                                <td class="header-row-main">
                                    <p>{{ j }}</p>
                                </td>}
                        </tr>
                        </tbody>
                    </table>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button (click)="back($event)" type="button" class="btn btn-secondary" value="Cancel">
				@if (fieldPlanStep === 1) {<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel">Cancel</span>} @else {
					<span jhiTranslate="back">Back</span>
                }
            </button>
            @if (!isViewFieldMap) {
                @if (fieldPlanStep !== 3) {
                    <button (click)="continue($event)" class="btn btn-primary ms-2" [disabled]="disableNextButton()">
                        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
						<span jhiTranslate="next">Next</span>
                    </button>
                } @else {
                    <button (click)="saveFieldMap($event)" class="btn btn-primary ms-2">
                        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
						<span jhiTranslate="finish">Finish</span>
                    </button>
                }
            }
        </div>
    </div>
</div>
